import * as actionTypes from "../consts/actionTypes";

export function getCapAndCopayLinkByPlanCodeAction(planCode) {
    return {
        type: actionTypes.GET_CAPANDCOPAYLINK_BY_PLANCODE,
        payload: planCode
    };
}